import React, {useEffect} from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";
import marqueeEffect from "../../../hooks/marquee-effect";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

const AwardsCta = ({title, awards, image, video, special}) => {

    useEffect(() => {
        marqueeEffect(gsap.utils.toArray(".awards-cta__marquees-wrapper"), {paused: false, repeat: -1,});

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: `.awards-cta__inner`,
                start: 'bottom bottom',
                end: 'bottom top',
                scrub: true,
            },
        });


        tl.fromTo(
            `.awards-cta__inner .awards-cta__wrapper`,
            { yPercent: 0 },
            { yPercent: 35, ease: 'none' }
        );

        return () => {
            tl.kill()
        }
    }, []);

    return (
        <section className={`awards-cta${special ? ' special' : ''}${!image && !video ? ' special-no-image' : ''}`}>
            <div className='awards-cta__inner'>
                <div className='awards-cta__wrapper'>
                    { (image || video) && 
                    <div className='awards-cta__media'>
                        {image && !video && <Asset asset={image}/>}
                        {video && <video src={video} autoPlay loop muted playsInline/>}
                    </div>
                    }
                    <div className='awards-cta__info'>
                        {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
                        { awards?.length > 0 &&
                            <div className='awards-cta__marquees'>
                                <div className='awards-cta__marquees-wrapper'>
                                    {awards?.length > 0 && awards.map((el, i) => (
                                        <div key={i} className='awards-cta__item'>
                                            <Asset asset={el}/>
                                        </div>
                                    ))}
                                </div>
                                <div className='awards-cta__marquees-wrapper'>
                                    {awards?.length > 0 && awards.map((el, i) => (
                                        <div key={i} className='awards-cta__item'>
                                            <Asset asset={el}/>
                                        </div>
                                    ))}
                                </div>
                                <div className='awards-cta__marquees-wrapper'>
                                    {awards?.length > 0 && awards.map((el, i) => (
                                        <div key={i} className='awards-cta__item'>
                                            <Asset asset={el}/>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AwardsCta

export const query = graphql`
fragment AwardsCtaProps on DatoCmsAwardsCta {
  ... on DatoCmsAwardsCta {
    id
    video
    title
    image {
      ...InternalAssetProps
    }
    awards {
      ...InternalAssetProps
    }
    special
  }
}
`;